export default {
    BOUNDED: "BOUNDED",
    FIXED: "FIXED",
    FREE: "FREE",
    SHRINK: "SHRINK"
}
